import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/notications-center')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/messages',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
